import { Injectable } from '@angular/core';
import { loadStripe, Stripe } from '@stripe/stripe-js';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root',
})
export class StripeLoader {
  private stripe: Stripe | null;

  async load() {
    if (!this.stripe) {
      this.stripe = await loadStripe(environment.stripeApiKey);
    }

    if (!this.stripe) {
      throw new Error('Failed to load Stripe');
    }

    return this.stripe;
  }
}
